
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vquiz",
      function () {
        return require("private-next-pages/vquiz/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vquiz"])
      });
    }
  